var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"contentSubTitle mb15"},[_vm._v("커스텀 필드")]),_c('div',{staticClass:"mb10"},[_c('button',{staticClass:"btn btnWhite"},[_vm._v(_vm._s(_vm.locale.add))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }